export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/sparkles-icon.png?49cadd4e938a9087967339b7ca97d9d5";